import { SpecialAnchorTypes } from '@labradorsports/constants';

import { PluginContext } from '../../plugins/api.js';
import {
    generateRouteOptionAnchors,
    generateRouteOptionLines,
    generateRouteOptionSelectedAnchors,
    handleRouteOptionDrag,
    handleRouteOptionDragEnd,
} from '../../utils/index.js';
import { getFootballToolFrameIdx } from '../move-placement-frame.js';
import PlayConfig from '../play-config.js';

const { ToolTypes } = PlayConfig;

// Football route options snap to the same 45° angle grid as football moves.
const footballRouteOptionOptions = { snapToAngleGrid: true };

export default {
    types: [ToolTypes.ROUTE_OPTION, SpecialAnchorTypes.ROUTE_OPTION_START],
    specialAnchorTypes: [SpecialAnchorTypes.ROUTE_OPTION_ELBOW],

    generateAnchors: ({ play }) => {
        const anchors = [];

        if (!play.fieldSetup) {
            play.frameSnapshots.forEach((frame, frameIdx) => {
                anchors.unshift(
                    ...generateRouteOptionAnchors({ play, frame }).map((a) => ({
                        ...a,
                        frameIdx,
                    }))
                );
            });
        }

        return anchors;
    },

    generateSelectedAnchors: generateRouteOptionSelectedAnchors,

    generateLines: ({ play }) => {
        if (play.fieldSetup) return [];

        return play.frameSnapshots.flatMap((frame, frameIdx) =>
            generateRouteOptionLines({ play, frame }).map((line) => ({
                ...line,
                frameIdx,
            }))
        );
    },

    handleDragEnd: ({ api, play, fieldViewport }, anchor, offset) => {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = play.frameSnapshots[frameIdx];

        const wrappedApi = {
            ...api,
            updateRouteOption: (update: any) => api.updateRouteOption(update, frameIdx),
        };

        handleRouteOptionDragEnd(
            { api: wrappedApi, play, frame, fieldViewport },
            anchor,
            offset,
            footballRouteOptionOptions
        );
    },

    handleDrag({ play, fieldViewport, frames }, anchor, offset, clamped) {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = frames[frameIdx];

        return handleRouteOptionDrag(
            { play, frame, fieldViewport },
            anchor,
            offset,
            clamped,
            footballRouteOptionOptions
        );
    },
} as PlayPlugin<PluginContext>;
